import _ from 'underscore';
import { ITaggedItemInfo } from '../models/resourceInfoParts';
import { Set } from '../models/Set';

export module TagsHelper {

  export interface ITagsChange {
    addTags: string[];
    removeTags: string[];
  }

  export function tagsListFromTaggedItemSet(taggedSet: Set<ITaggedItemInfo>): string[] {
    let allTags: string[] = [];
    taggedSet.each((taggedItem: ITaggedItemInfo) => {
      allTags.push(...taggedItem.tags);
    });

    return getUniqueTagsAndSort(allTags);
  }

  export function tagsListFromTaggedItemArray(taggedSet: any[]): string[] {
    let allTags: string[] = [];
    _.each(taggedSet, ((taggedItem: ITaggedItemInfo) => {
      allTags.push(...taggedItem.tags);
    }));

    return getUniqueTagsAndSort(allTags);
  }

  function getUniqueTagsAndSort(allTags: string[]): string[] {
    const uniqueTags = _.unique(allTags);
    return _.sortBy(uniqueTags, (tagName: string) => tagName.toLowerCase());
  }

  export function parseTagString(tagString: string): string[] {
    const tagList: string[] = [];
    tagString = tagString.replace(/"[^"]*?"/g, function(quotedTag) {
      tagList.push(quotedTag);
      return '';
    });

    const splitTags = _.flatten(_.map(tagString.split(','), (commaSplitTag) => commaSplitTag.split(' ')));
    return _.union<string>(tagList, splitTags);
  }

  export function quote(tag: string): string {
    return _.contains(tag, '"') ? tag : ('"' + tag + '"');
  }

  export function unquote(tag: string): string {
    return tag.replace(/^"([^"]*)"$/, '$1');
  }

  export function displayTagHtml(tag: string): string {
    return _.escape(unquote(tag)).replace(/ /g, '&nbsp;');
  }

}
